import { isNumeric } from '../../util/helpers';
import { parseLatLon } from '../../airport/util/parseUtils';
import { BusinessFinderResult } from './business-finder-result.model';

/**
 * A flying-club search result returned by the AirportsAPI `~/flying-clubs` endpoint. A flying club is a
 * business carrying the "Flying Club" tag (TagId 165). Mirrors the `AviationEvent` model's
 * `static parse` convention.
 */
export class FlyingClubResult extends BusinessFinderResult {

  /**
   * "AOPA Network Club", "Club In Formation", or "Flying Club".
   */
  clubType: string;

  /**
   * True when the club is accepting new members (Flying Club::Membership::Open).
   */
  newMembers: boolean;

  clubMembers: number;

  clubAircraft: number;

  /**
   * Thumbnail image for the results card (club logo or first photo). Null when the club has no photo.
   */
  thumbnailPhotoPath: string;

  static parse(data: any): FlyingClubResult {
    return Object.assign(new FlyingClubResult(), {
      businessId: data.businessId,
      name: data.name || null,
      city: data.city || null,
      stateProvince: data.stateProvince || null,
      latitude: isNumeric(data.latitude) ? +data.latitude : null,
      longitude: isNumeric(data.longitude) ? +data.longitude : null,
      location: (isNumeric(data.latitude) && isNumeric(data.longitude))
        ? parseLatLon(data.latitude, data.longitude) : null,
      phone1: data.phone1 || null,
      webAddress: data.webAddress || null,
      emailAddress: data.emailAddress || null,
      description: data.description || null,
      distance: isNumeric(data.distance) ? +data.distance : null,
      airportIdent: data.airportIdent || null,
      airportName: data.airportName || null,
      tags: (data.tags || []).map(d => d),
      clubType: data.clubType || null,
      newMembers: data.newMembers || false,
      clubMembers: isNumeric(data.clubMembers) ? +data.clubMembers : null,
      clubAircraft: isNumeric(data.clubAircraft) ? +data.clubAircraft : null,
      thumbnailPhotoPath: data.thumbnailPhotoPath || null
    });
  }
}
